import React from 'react';
import PriceTargetsWidgetBuilder from './PriceTargetsWidgetBuilder';
import PriceTargetsWidgetRenderer from './PriceTargetsWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { PriceTargetsWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';

export { default as PriceTargetsWidgetRenderer } from './PriceTargetsWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'price_targets',
  meta: {
    label: 'Price Targets & Ratings',
    icon: React.createElement(FontAwesomeIcon, { icon: faBullseye }),
    description: 'Sell-side consensus 12-month price target, implied upside, and buy/hold/sell distribution',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'PRICE_TARGETS',
  },
  defaultSize: { w: 5, h: 4, minW: 3, minH: 3 },
  defaultConfig: () => ({} as PriceTargetsWidgetConfig),
  Builder: PriceTargetsWidgetBuilder,
  Renderer: PriceTargetsWidgetRenderer,
  Preview,
};
